// PHP can't distinguish between empty array and empty objects
// this function sanitizes an empty array into an empty object
export default function castEmptyArrayToObject(objectOrArray) {
    if (objectOrArray instanceof Array && objectOrArray.length === 0) {
        return {};
    } else {
        return objectOrArray;
    }
}



// WEBPACK FOOTER //
// ./src/web/js/contest/utils/cast-empty-array-to-object.js